import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import useProducts from "../../../../hooks/context/useProducts";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { CustomModal } from "../../Organisms";
import { useState } from "react";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import { colors } from "../../../../theme/colors";
import { FormControlMenu } from "./FormControl";

export function LateralFilters() {
  const { productsDataMemo, productsfilters } = useProducts();
  const { isSmalldesktop } = useBreakpoints();
  const [params, setSearchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const versionNow = params.get("versionName");
  const originNow = params.get("originName");
  const nameNow = params.get("name");
  const tabNow = params.get("tab");
  const inStockNow = params.get("inStock");
  const outOfStockNow = params.get("outOfStock");
  const isRareNow = params.get("isRare");
  const productTypeNow = params.get("productTypeName");

  const Radios = () => (
    <>
      <FormControl>
        <FormLabel
          id="quantity-labels"
          sx={{
            height: 36,
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
          }}
        >
          Estoque
          <Button
            variant="text"
            onClick={() =>
              setSearchParams(
                createSearchParams({
                  ...(nameNow && {
                    name: nameNow,
                  }),
                  ...(versionNow && {
                    versionName: versionNow,
                  }),
                  ...(originNow && {
                    originName: originNow,
                  }),
                  ...(isRareNow && {
                    isRare: isRareNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  tab: String(tabNow),
                })
              )
            }
          >
            X
          </Button>
        </FormLabel>

        <RadioGroup>
          <FormControlLabel
            value={true}
            control={<Radio />}
            label={"Em estoque"}
            sx={{ fontWeight: 700 }}
            onChange={() => {
              setSearchParams(
                createSearchParams({
                  ...(nameNow && {
                    name: nameNow,
                  }),
                  ...(versionNow && {
                    versionName: versionNow,
                  }),
                  ...(originNow && {
                    originName: originNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  ...(isRareNow && {
                    isRare: isRareNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  inStock: "true",
                  tab: String(tabNow),
                })
              );
            }}
            checked={inStockNow ? true : false}
          />

          <FormControlLabel
            value={true}
            control={<Radio />}
            label={"Fora de estoque"}
            sx={{ fontWeight: 700 }}
            onChange={() => {
              setSearchParams(
                createSearchParams({
                  ...(nameNow && {
                    name: nameNow,
                  }),
                  ...(versionNow && {
                    versionName: versionNow,
                  }),
                  ...(originNow && {
                    originName: originNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  ...(isRareNow && {
                    isRare: isRareNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  outOfStock: "true",
                  tab: String(tabNow),
                })
              );
            }}
            checked={outOfStockNow ? true : false}
          />
        </RadioGroup>
      </FormControl>

      <FormControl>
        <FormLabel
          id="quantity-labels"
          sx={{
            height: 36,
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
          }}
        >
          Especificações
          <Button
            variant="text"
            onClick={() =>
              setSearchParams(
                createSearchParams({
                  ...(nameNow && {
                    name: nameNow,
                  }),
                  ...(versionNow && {
                    versionName: versionNow,
                  }),
                  ...(inStockNow && {
                    inStock: inStockNow,
                  }),
                  ...(outOfStockNow && {
                    outOfStock: outOfStockNow,
                  }),
                  ...(originNow && {
                    originName: originNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  tab: String(tabNow),
                })
              )
            }
          >
            X
          </Button>
        </FormLabel>

        <RadioGroup>
          <FormControlLabel
            value={true}
            control={<Radio />}
            label={"Raro"}
            sx={{ fontWeight: 700 }}
            onChange={() => {
              setSearchParams(
                createSearchParams({
                  ...(nameNow && {
                    name: nameNow,
                  }),
                  ...(versionNow && {
                    versionName: versionNow,
                  }),
                  ...(inStockNow && {
                    inStock: inStockNow,
                  }),
                  ...(outOfStockNow && {
                    outOfStock: outOfStockNow,
                  }),
                  ...(originNow && {
                    originName: originNow,
                  }),
                  ...(productTypeNow && {
                    productTypeName: productTypeNow,
                  }),
                  isRare: "true",
                  tab: String(tabNow),
                })
              );
            }}
            checked={isRareNow ? true : false}
          />
        </RadioGroup>
      </FormControl>

      <FormControlMenu
        menuName="Tipo"
        active={productsfilters.productTypeName ? true : false}
        onRemove={() =>
          setSearchParams(
            createSearchParams({
              ...(nameNow && {
                name: nameNow,
              }),
              ...(versionNow && {
                versionName: versionNow,
              }),
              ...(inStockNow && {
                inStock: inStockNow,
              }),
              ...(outOfStockNow && {
                outOfStock: outOfStockNow,
              }),
              ...(originNow && {
                originName: originNow,
              }),
              ...(isRareNow && {
                isRare: isRareNow,
              }),
              tab: String(tabNow),
            })
          )
        }
        checked={productTypeNow}
        list={productsDataMemo?.productType}
        onChange={(item) =>
          setSearchParams(
            createSearchParams({
              ...(nameNow && {
                name: nameNow,
              }),
              ...(versionNow && {
                versionName: versionNow,
              }),
              ...(inStockNow && {
                inStock: inStockNow,
              }),
              ...(outOfStockNow && {
                outOfStock: outOfStockNow,
              }),
              ...(originNow && {
                originName: originNow,
              }),
              ...(isRareNow && {
                isRare: isRareNow,
              }),
              productTypeName: item?.name,
              tab: String(tabNow),
            })
          )
        }
      />

      <FormControlMenu
        menuName="Origem"
        active={productsfilters.originName ? true : false}
        onRemove={() =>
          setSearchParams(
            createSearchParams({
              ...(nameNow && {
                name: nameNow,
              }),
              ...(versionNow && {
                versionName: versionNow,
              }),
              ...(inStockNow && {
                inStock: inStockNow,
              }),
              ...(outOfStockNow && {
                outOfStock: outOfStockNow,
              }),
              ...(isRareNow && {
                isRare: isRareNow,
              }),
              ...(productTypeNow && {
                productTypeName: productTypeNow,
              }),
              tab: String(tabNow),
            })
          )
        }
        checked={originNow}
        list={productsDataMemo?.origins}
        onChange={(item) =>
          setSearchParams(
            createSearchParams({
              ...(nameNow && {
                name: nameNow,
              }),
              ...(versionNow && {
                versionName: versionNow,
              }),
              ...(inStockNow && {
                inStock: inStockNow,
              }),
              ...(outOfStockNow && {
                outOfStock: outOfStockNow,
              }),
              ...(isRareNow && {
                isRare: isRareNow,
              }),
              ...(productTypeNow && {
                productTypeName: productTypeNow,
              }),
              originName: item?.name,
              tab: String(tabNow),
            })
          )
        }
      />

      <FormControlMenu
        menuName="Versão"
        active={productsfilters.versionName ? true : false}
        onRemove={() =>
          setSearchParams(
            createSearchParams({
              ...(nameNow && {
                name: nameNow,
              }),
              ...(originNow && {
                originName: originNow,
              }),
              ...(inStockNow && {
                inStock: inStockNow,
              }),
              ...(outOfStockNow && {
                outOfStock: outOfStockNow,
              }),
              ...(isRareNow && {
                isRare: isRareNow,
              }),
              ...(productTypeNow && {
                productTypeName: productTypeNow,
              }),
              tab: String(tabNow),
            })
          )
        }
        checked={versionNow}
        list={productsDataMemo?.versions}
        onChange={(item) =>
          setSearchParams(
            createSearchParams({
              ...(nameNow && {
                name: nameNow,
              }),
              ...(originNow && {
                originName: originNow,
              }),
              ...(inStockNow && {
                inStock: inStockNow,
              }),
              ...(outOfStockNow && {
                outOfStock: outOfStockNow,
              }),
              ...(isRareNow && {
                isRare: isRareNow,
              }),
              ...(productTypeNow && {
                productTypeName: productTypeNow,
              }),
              versionName: item?.name,
              tab: String(tabNow),
            })
          )
        }
      />
    </>
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems={isSmalldesktop ? "center" : "flex-start"}
      gap={3}
      width={isSmalldesktop ? "100%" : "15%"}
      minWidth={150}
      height={"100%"}
      mt={2}
      sx={{
        p: isSmalldesktop ? 0 : 5,
        borderRadius: 5,
      }}
    >
      {!isSmalldesktop && (
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Typography
            sx={{
              color: colors.textGrey[700],
              textAlign: "left",
              fontSize: 22,
              fontWeight: 800,
            }}
          >
            Filtrar
          </Typography>
        </Box>
      )}
      {isSmalldesktop ? (
        <>
          <Button
            variant="contained"
            style={{ width: "90%", marginBottom: 30 }}
            onClick={() => setOpenModal(true)}
          >
            Refine sua busca
          </Button>
          <CustomModal
            width={"90%"}
            openModal={openModal}
            setOpenModal={setOpenModal}
            title="Filter"
          >
            <Box
              px={3}
              py={1}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
            >
              <Radios />
            </Box>
          </CustomModal>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mt: isSmalldesktop ? 0 : 5,
            gap: 3,
          }}
          id="radios_cp"
        >
          <Radios />
        </Box>
      )}
    </Box>
  );
}
